import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { WellApiService } from '../../services/api/well.api.service';
import { CrudService } from '../../services/crud.service';
import { debounceTime, distinctUntilChanged, filter, skip, take, takeUntil } from 'rxjs/operators';
import { combineLatest, Subject, Subscription } from 'rxjs';
import { ConstantsApiService } from 'src/app/services/api/constants.api.service';
import { UserApiService } from 'src/app/services/api/user.api.service';
import { SearchApiService } from 'src/app/services/api/search.api.service';
import { TicketDialogComponent } from '../ticket-dialog/ticket-dialog.component';
import { OrderApiService } from 'src/app/services/api/order.api.service';
import { UserService } from '../../services/user.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ReasonDialogComponent } from '../reason-dialog/reason-dialog.component';
import { WellService } from 'src/app/services/well.service';
import { ErrorHandlingService } from 'src/app/services/error-handling.service';
import { HelperService } from '~services/helper.service';
import { LOCAL_STORAGE_CONST } from '../../constants/local-storage-constants';
import { FormControl } from '@angular/forms';
import { ConfirmActionDialogComponent } from '../confirm-action-dialog/confirm-action-dialog.component';

const PAGE_SIZE = 100;
const PAGE_SIZE_INVOICE = 100;
const BILLING_STATUS = {
  notBilled: 'not_billed',
  approvedByDispatcher: 'approved_by_dispatcher',
  approvedByLMO: 'approved_by_lmo',
  billed: 'billed',
  approved: 'approved',
};

const TABS = {
  NEED_DATA_FOR_TICKETING: 'needDataForTicketing',
  WAITING_FOR_TICKET_APPROVAL: 'waitingForTicketApproval',
  READY_FOR_INVOICING: 'readyForInvoicing',
  WAITING_FOR_INVOICE_APPROVAL: 'waitingForInvoiceApproval',
  INVOICE_APPROVED: 'invoiceApproved',
};

interface Filters {
  isAutomated: boolean;
  isManual: boolean;
  pushback: boolean;
  attachmentFilter: boolean;
  dataMatchedFilter: boolean;
  fastTrackedFilter: boolean;
  needsManualApprovalPricing: boolean;
  needsManualApprovalTrip: boolean;
  needsManualApprovalBOL: boolean;
  needData: boolean;
  manuallyEdited: boolean;
  pageLimit: string;
  pageOffset: number;
  pageColumn: number;
  pageIndex: number;
  pageOrderBy: string;
  searchData: string;
  pushedBackInvoiceNumber: string;
  olderThanTwoDays: boolean;
}

interface InvoiceFilter {
  pageIndexInvoice: number;
  pageOffsetInvoice: number;
  pageLimitInvoice: number;
  approved: boolean;
}
interface StoredFilter {
  needDataForTicketing: Filters;
  waitingForTicketApproval: Filters;
  readyForInvoicing: Filters;
  waitingForInvoiceApproval: InvoiceFilter;
  invoiceApproved: InvoiceFilter;
}

@Component({
  selector: 'sa-order-table',
  templateUrl: './order-table.component.html',
  styleUrls: ['./order-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('125ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('125ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('125ms ease-in', style({ transform: 'translateX(-0%)' })),
      ]),
      transition(':leave', [animate('125ms ease-in', style({ transform: 'translateX(100%)' }))]),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate('125ms ease-in', style({ opacity: 1 }))]),
      transition(':leave', [animate('125ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class OrderTableComponent implements OnInit, OnDestroy {
  completedOrders: any;
  ordersTooltips: any[] = [];
  completeInvoices: any;
  selectedOrderId: any;
  urlRoute = '';
  urlOrderId: number;
  detailView = false;
  selectedFracId = 0;

  isAutomated = true;
  isManual = true;
  pushback = true;
  attachmentFilter = false;
  pushedBackInvoiceNumber = '';
  dataMatchedFilter = false;
  receivedByCustomer = false;
  olderThanTwoDays = false;
  fastTrackedFilter = false;
  needsManualApprovalPricing = true;
  needsManualApprovalTrip = true;
  needsManualApprovalBOL = true;
  orderedAfterFilter: any;

  needData = true;
  manuallyEdited = true;

  driverList: any;
  truckList: any;
  payloadList: any;
  responseNumber = 0;

  isLmoAccount = false;
  pageLimit = 100;
  pageOffset = 0;
  pageIndex = 0;
  pageOffsetInvoice = 0;
  pageIndexInvoice = 0;
  pageLimitInvoice = 100;
  pageColumn = 'dispatchTimestamp';
  pageOrderBy = 'asc';
  orderCount = 0;
  invoiceCount = 0;
  searchData = '';
  invoices: any[];
  storedFilter: StoredFilter = {
    needDataForTicketing: {} as Filters,
    waitingForTicketApproval: {} as Filters,
    readyForInvoicing: {} as Filters,
    waitingForInvoiceApproval: {} as InvoiceFilter,
    invoiceApproved: {} as InvoiceFilter,
  };
  isLoading = true;
  isSubLoading = false;
  subs = [];
  exporting: boolean[] = [];
  customInput: Subject<string> = new Subject();
  activeDataSource = new MatTableDataSource([]);

  searchNumber = 0;
  displayedColumns = [];
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  @ViewChild('paginatorInvoice', { static: false }) paginatorInvoice: MatPaginator;
  public savingData = false;

  invoiceDataSource = new MatTableDataSource([]);
  columnsToDisplay = [];
  subTableColumns = [];
  truckingVendorsList = [];
  expandedElement: any;
  useShaleAppsInvoiceNumber = false;
  singleOrderPerInvoice = false;
  groupByInvoiceFilter = new FormControl(true);
  private destroy$ = new Subject();

  private dataAPICall: Subscription;

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.activeDataSource.data.length > 100 ? 100 : this.activeDataSource.data.length;
    return numSelected === numRows;
  }

  isAllInvoiceSelected() {
    const numSelected = this.selection.selected.length;
    let numRows = 0;
    if (this.invoiceDataSource.data) {
      numRows = this.invoiceDataSource.data.length > 100 ? 100 : this.invoiceDataSource.data.length;
    }
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.activeDataSource.data.forEach((row) => {
          if (row.loadNumber) {
            this.selection.select(row);
          }
        });
  }

  invoiceMasterToggle() {
    this.isAllInvoiceSelected()
      ? this.selection.clear()
      : this.invoiceDataSource.data.forEach((row) => {
          if (row.InvoiceNumber) {
            this.selection.select(row);
          }
        });
  }

  constructor(
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private wellApiService: WellApiService,
    private constantsApiService: ConstantsApiService,
    private userAPIService: UserApiService,
    private searchAPIService: SearchApiService,
    private crud: CrudService,
    private orderApiService: OrderApiService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private userService: UserService,
    public wellService: WellService,
    private errorHandler: ErrorHandlingService,
    public helperService: HelperService,
  ) {}

  ngOnInit() {
    this.selectedFracId = this.route.parent.snapshot.params['id'];
    this.olderThanTwoDays =
      Object.keys(this.route.snapshot.queryParams).length > 0
        ? this.route.snapshot.queryParams['older']
        : this.olderThanTwoDays;
    this.urlOrderId = this.route.firstChild && this.route.firstChild.snapshot.params['orderId'];
    this.searchListener();
    this.loadBaseData();
    this.setOrderedAfterListener();
    this.subs.push(
      this.route.params.pipe(skip(1)).subscribe((params) => {
        this.applyStoredFilters();
        this.pageLimitInvoice = 100;
        this.pageIndexInvoice = 0;
        this.pageOffsetInvoice = 0;
        this.fetchData();
      }),
    );
    if (this.userService.isLMOAccount()) {
      this.isLmoAccount = true;
    }
  }

  private applyStoredFilters() {
    const url = this.route.snapshot.params['tab'];
    if (
      url !== TABS.WAITING_FOR_INVOICE_APPROVAL &&
      url !== TABS.INVOICE_APPROVED &&
      this.storedFilter &&
      this.storedFilter[url] &&
      this.storedFilter[url].isAutomated
    ) {
      this.isAutomated = this.storedFilter[url].isAutomated;
      this.isManual = this.storedFilter[url].isManual;
      this.pushback = this.storedFilter[url].pushback;
      this.attachmentFilter = this.storedFilter[url].attachmentFilter;
      this.olderThanTwoDays = this.storedFilter[url].olderThanTwoDays;
      this.pushedBackInvoiceNumber = this.storedFilter[url].pushedBackInvoiceNumber;
      this.dataMatchedFilter = this.storedFilter[url].dataMatchedFilter;
      this.fastTrackedFilter = this.storedFilter[url].fastTrackedFilter;
      this.needsManualApprovalPricing = this.storedFilter[url].needsManualApprovalPricing;
      this.needsManualApprovalTrip = this.storedFilter[url].needsManualApprovalTrip;
      this.needsManualApprovalBOL = this.storedFilter[url].needsManualApprovalBOL;
      this.needData = this.storedFilter[url].needData;
      this.manuallyEdited = this.storedFilter[url].manuallyEdited;
      this.pageLimit = this.storedFilter[url].pageLimit;
      this.pageOffset = this.storedFilter[url].pageOffset;
      this.pageColumn = this.storedFilter[url].pageColumn;
      this.pageOrderBy = this.storedFilter[url].pageOrderBy;
      this.searchData = this.storedFilter[url].searchData;
      this.pageIndex = this.storedFilter[url].pageIndex;
    }
    // else
    //   if (
    //     this.storedFilter &&
    //     this.storedFilter[url] &&
    //     this.storedFilter[url].pageIndexInvoice >= 0
    //   ) {
    //     this.pageLimitInvoice = this.storedFilter[url].pageLimitInvoice;
    //     this.pageOffsetInvoice = this.storedFilter[url].pageOffsetInvoice;
    //     this.pageIndexInvoice = this.storedFilter[url].pageIndexInvoice;
    //   }
  }

  openDetailView(id) {
    this.selectedOrderId = id;
    this.detailView = true;
  }

  searchListener() {
    this.customInput.pipe(takeUntil(this.destroy$), debounceTime(300), distinctUntilChanged()).subscribe((value) => {
      value = value.toLowerCase();
      this.searchData = value;
      this.loadData();
    });
    const localGroupFilter = JSON.parse(localStorage.getItem(LOCAL_STORAGE_CONST.GROUP_BY_INVOICE_FILTER));
    if (localGroupFilter != null) {
      this.groupByInvoiceFilter.setValue(localGroupFilter);
    }
    this.groupByInvoiceFilter.valueChanges.pipe(takeUntil(this.destroy$), distinctUntilChanged()).subscribe((value) => {
      localStorage.setItem(LOCAL_STORAGE_CONST.GROUP_BY_INVOICE_FILTER, value);
      this.fetchData();
    });
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
    this.subs.forEach((sub: Subscription) => {
      if (!sub.closed) {
        sub.unsubscribe();
      }
    });
  }

  loadBaseData() {
    if (isNaN(this.selectedFracId)) {
      return;
    }
    this.wellService.setValue({});
    this.truckingVendorsList = [];
    this.crud.httpClientReady.pipe(filter(Boolean), take(1)).subscribe((_) => {
      combineLatest([
        this.wellApiService.getWellMinimal(this.selectedFracId),
        this.constantsApiService.getMeshTypes(),
        this.userAPIService.getDrivers(),
        this.searchAPIService.allTrucks(),
      ])
        .pipe(takeUntil(this.destroy$))
        .subscribe(([well, meshes, drivers, trucks]) => {
          this.payloadList = meshes;
          this.driverList = drivers;
          this.truckList = trucks;
          this.sortVendors(well.fracClusterTruckingVendors || []);
          this.sortTrucks();
          this.fetchData();
          if (well.pushedbackBills && well.pushedbackBills.length) {
            well.pushedbackBills = well.pushedbackBills.sort((a, b) => {
              return new Date(b.RejectionTime).getTime() - new Date(a.RejectionTime).getTime();
            });
          }
          this.useShaleAppsInvoiceNumber = well.useShaleAppInvoiceNumber;
          this.singleOrderPerInvoice = well.singleOrderPerInvoice;
          this.wellService.setValue(well);
        });
    });
  }

  setOrderedAfterListener() {
    this.wellService.orderedAfterFilter$.pipe(skip(1), takeUntil(this.destroy$)).subscribe((dateTime) => {
      this.orderedAfterFilter = dateTime;
      this.fetchData();
    });
  }

  reloadFracData() {
    if (isNaN(this.selectedFracId)) {
      return;
    }
    this.wellApiService
      .getWellMinimal(this.selectedFracId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((well) => {
        this.wellService.setValue(well);
        this.fetchData();
      });
  }

  sortVendors(vendors) {
    vendors.forEach((vendor) => {
      let found = false;
      for (let i = 0; i < this.truckingVendorsList.length; i++) {
        if (this.truckingVendorsList[i].truckingVendorId === vendor.truckingVendorId) {
          found = true;
          break;
        }
      }
      if (!found) {
        vendor.filter = true;
        this.truckingVendorsList.push(vendor);
      }
    });
  }

  sortTrucks() {
    const result = this.truckList.reduce((unique, o) => {
      if (!unique.some((obj) => obj.id === o.id && obj.name === o.name)) {
        unique.push(o);
      }
      return unique;
    }, []);
    this.truckList = result;
  }

  inputValueChanged(event) {
    this.customInput.next(event);
  }

  getLoadWeight(order) {
    if (order.boxes) {
      let sum = 0;
      order.boxes.forEach((box) => {
        if (box.actualLoadWeight) {
          sum += box.actualLoadWeight;
        }
      });
      return sum + ' lbs';
    } else if (order.actualLoadWeight) {
      return order.actualLoadWeight + ' lbs';
    } else {
      return '-';
    }
  }

  sortListener(sortData) {
    this.pageColumn = sortData.active;
    this.pageOrderBy = sortData.direction;
    this.loadData();
  }

  fetchData() {
    this.selection.clear();
    this.isLoading = true;
    this.urlRoute = this.route.snapshot.params['tab'];
    this.urlRoute = this.urlRoute.split('?')[0];
    switch (this.urlRoute) {
      case TABS.READY_FOR_INVOICING: {
        if (this.isLmoAccount) {
          this.displayedColumns = [
            'loadNumber',
            'vendor',
            'name',
            'dispatchTimestamp',
            'mesh',
            'actualLoadWeight',
            'cost',
            'setting',
          ];
        } else {
          this.displayedColumns = [
            'select',
            'loadNumber',
            'name',
            'dispatchTimestamp',
            'mesh',
            'actualLoadWeight',
            'cost',
            'setting',
          ];
        }
        break;
      }
      case TABS.NEED_DATA_FOR_TICKETING: {
        if (this.isLmoAccount) {
          this.displayedColumns = [
            'status',
            'loadNumber',
            'vendor',
            'name',
            'dispatchTimestamp',
            'mesh',
            'actualLoadWeight',
            'cost',
            'setting',
          ];
        } else {
          this.displayedColumns = [
            'status',
            'loadNumber',
            'name',
            'dispatchTimestamp',
            'mesh',
            'actualLoadWeight',
            'cost',
            'setting',
          ];
        }
        break;
      }
      case TABS.WAITING_FOR_TICKET_APPROVAL: {
        if (this.isLmoAccount) {
          this.displayedColumns = [
            'status',
            'loadNumber',
            'vendor',
            'name',
            'dispatchTimestamp',
            'mesh',
            'actualLoadWeight',
            'cost',
            'setting',
          ];
          if (this.userService.hasPermission('can_approve_ticket')) {
            this.displayedColumns.unshift('select');
          }
        } else {
          this.displayedColumns = [
            'status',
            'loadNumber',
            'name',
            'dispatchTimestamp',
            'mesh',
            'actualLoadWeight',
            'cost',
            'setting',
          ];
        }
        break;
      }
      case TABS.WAITING_FOR_INVOICE_APPROVAL: {
        if (!this.groupByInvoiceFilter.value) {
          if (this.isLmoAccount) {
            this.displayedColumns = [
              'status',
              'loadNumber',
              'invoiceNumber',
              'vendor',
              'name',
              'dispatchTimestamp',
              'mesh',
              'actualLoadWeight',
              'cost',
            ];
            if (this.userService.hasPermission('can_approve_ticket')) {
              this.displayedColumns.unshift('select');
            }
          } else {
            this.displayedColumns = [
              'status',
              'loadNumber',
              'invoiceNumber',
              'name',
              'dispatchTimestamp',
              'mesh',
              'actualLoadWeight',
              'cost',
            ];
          }
        } else {
          if (this.isLmoAccount) {
            this.columnsToDisplay = ['InvoiceNumber', 'vendorName', 'statusChangedTime', 'TotalCost', 'OrderCount'];
            this.subTableColumns = [
              'status',
              'loadNumber',
              'vendor',
              'name',
              'dispatchTimestamp',
              'mesh',
              'actualLoadWeight',
              'cost',
            ];
            if (this.userService.hasPermission('can_approve_invoice')) {
              this.columnsToDisplay.unshift('select');
            }
          } else {
            this.columnsToDisplay = ['InvoiceNumber', 'TotalCost', 'statusChangedTime', 'OrderCount'];
            this.subTableColumns = [
              'status',
              'loadNumber',
              'name',
              'dispatchTimestamp',
              'mesh',
              'actualLoadWeight',
              'cost',
            ];
          }
        }
        break;
      }
      case TABS.INVOICE_APPROVED: {
        if (!this.groupByInvoiceFilter.value) {
          if (this.isLmoAccount) {
            this.displayedColumns = [
              'status',
              'loadNumber',
              'invoiceNumber',
              'vendor',
              'name',
              'dispatchTimestamp',
              'mesh',
              'actualLoadWeight',
              'cost',
              'Export',
            ];
            if (this.userService.hasPermission('can_approve_invoice')) {
              this.displayedColumns.push('Actions');
            }
          } else {
            this.displayedColumns = [
              'status',
              'loadNumber',
              'invoiceNumber',
              'name',
              'dispatchTimestamp',
              'mesh',
              'actualLoadWeight',
              'cost',
              'Export',
            ];
          }
        } else {
          if (this.isLmoAccount) {
            this.columnsToDisplay = [
              'InvoiceNumber',
              'TotalCost',
              'OrderCount',
              'statusChangedTime',
              'vendorName',
              'ApprovedByName',
              'Export',
            ];
            this.subTableColumns = [
              'status',
              'loadNumber',
              'vendor',
              'name',
              'dispatchTimestamp',
              'mesh',
              'actualLoadWeight',
              'cost',
            ];
            if (this.userService.hasPermission('can_approve_invoice')) {
              this.columnsToDisplay.push('Actions');
            }
          } else {
            this.columnsToDisplay = ['InvoiceNumber', 'TotalCost', 'statusChangedTime', 'OrderCount', 'Export'];
            this.subTableColumns = [
              'status',
              'loadNumber',
              'name',
              'dispatchTimestamp',
              'mesh',
              'actualLoadWeight',
              'cost',
            ];
          }
        }
        break;
      }
      default: {
        if (this.isLmoAccount) {
          this.displayedColumns = [
            'loadNumber',
            'vendor',
            'name',
            'dispatchTimestamp',
            'mesh',
            'actualLoadWeight',
            'cost',
            'setting',
          ];
        } else {
          this.displayedColumns = [
            'loadNumber',
            'name',
            'dispatchTimestamp',
            'mesh',
            'actualLoadWeight',
            'cost',
            'setting',
          ];
        }
      }
    }
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.urlRoute = val.url.split('/')[4];
        this.urlRoute = this.urlRoute && this.urlRoute.split('?')[0];
        const id = val.url.split('/')[5];
        if (id) {
          this.openDetailView(id);
        }
      }
    });
    if (this.urlOrderId) {
      this.openDetailView(this.urlOrderId);
    }
    this.crud.httpClientReady.pipe(filter(Boolean), take(1)).subscribe((_) => {
      this.loadData();
    });
  }

  loadData() {
    let vendorIds = '';
    if (this.userService.isDispatcherAccount()) {
      vendorIds = `${this.userService.accountId()}`;
    }
    this.truckingVendorsList.forEach((vendor) => {
      if (vendor.filter) {
        vendorIds === '' ? (vendorIds += `${vendor.truckingVendorId}`) : (vendorIds += `,${vendor.truckingVendorId}`);
      }
    });
    this.isLoading = true;
    this.searchNumber++;
    if (this.showOrderTable()) {
      const params = {
        state: this.urlRoute,
        autoApprove: this.isAutomated,
        manualApprove: this.isManual,
        pushback: this.pushback,
        attachment: this.attachmentFilter,
        pushedBackInvoiceNumber: this.pushedBackInvoiceNumber,
        dataMatched: this.dataMatchedFilter,
        receivedByCustomer: this.receivedByCustomer,
        fastTracked: this.fastTrackedFilter,
        orderedAfter: (this.orderedAfterFilter && new Date(this.orderedAfterFilter).toISOString()) || '',
        needsManualApprovalPricing: this.needsManualApprovalPricing,
        needsManualApprovalTrip: this.needsManualApprovalTrip,
        needsManualApprovalBOL: this.needsManualApprovalBOL,
        olderThanTwoDays: this.olderThanTwoDays,

        needData: this.needData,
        manuallyEdited: this.manuallyEdited,
        vendorId: vendorIds,

        limit: this.pageLimit,
        offset: this.pageOffset,
        orderByColumn: this.pageColumn,
        orderBy: this.pageOrderBy,
        searchQuery: this.searchData,
      };
      this.searchOrders(params, this.searchNumber);
      this.updateFilterStore();
    } else {
      const body = {
        approved: false,
        limit: this.pageLimitInvoice,
        offset: this.pageOffsetInvoice,
        searchTerm: this.searchData,
        orderedAfter: (this.orderedAfterFilter && new Date(this.orderedAfterFilter).toISOString()) || '',
      };
      if (this.urlRoute === TABS.INVOICE_APPROVED) {
        body.approved = true;
      }
      this.responseNumber = this.responseNumber + 1;
      this.loadInvoiceDate(body, this.responseNumber);
    }
    this.wellService.getOrderCounts();
  }

  showOrderTable() {
    return !this.groupByInvoiceFilter.value || (this.groupByInvoiceFilter.value && !this.checkForInvoiceTabs());
  }

  checkForInvoiceTabs() {
    return this.urlRoute === TABS.WAITING_FOR_INVOICE_APPROVAL || this.urlRoute === TABS.INVOICE_APPROVED;
  }

  loadInvoiceDate(body, hit: number) {
    this.unsubscribeAPIDataCall();
    this.dataAPICall = this.wellApiService.getInvoices(this.selectedFracId, body).subscribe((invoices) => {
      if (hit === this.responseNumber) {
        this.completeInvoices = invoices.bills;
        this.invoiceCount = invoices.billsCount;
        this.initializeTable();
        this.invoices = invoices.bills;
        this.isLoading = false;
        // if (invoices.bills) {
        //   invoices.bills.forEach((invoice) => {
        //     const params = {
        //       invoiceNumber: invoice.InvoiceNumber.trim(),
        //       vendorId: invoice.vendorId,
        //     };
        //     this.loadInvoiceOrders(params, invoice);
        //     this.exporting.push(false);
        //   });
        // }
      }
      this.updateFilterStore();
    });
  }
  public applyInvoiceFilter(filterValue: string) {
    this.invoiceDataSource.filter = filterValue.trim().toLocaleLowerCase();
    this.invoiceDataSource.filterPredicate = (data, filterStr) => {
      const transformedFilter = filterStr.trim().toLocaleLowerCase();
      let filtered = false;
      // check if search includes invoice number
      if (data.InvoiceNumber && data.InvoiceNumber.toLocaleLowerCase().includes(transformedFilter)) {
        filtered = true;
      }
      // cannot always rely on invoice number starting with 'sa', but will look that way to user so want to accomodate that search
      if (
        transformedFilter.startsWith('sa') &&
        data.InvoiceNumber &&
        data.InvoiceNumber.toLocaleLowerCase().includes(transformedFilter.substring(2))
      ) {
        filtered = true;
      }
      // allow search by individual orders, which are a MatTableDataSource within a MatTableDataSource
      if (data.orders && data.orders.data) {
        data.orders.data.forEach((order) => {
          if (
            JSON.stringify(order.id).includes(transformedFilter) ||
            order.saUniqueId.toLocaleLowerCase().includes(transformedFilter)
          ) {
            filtered = true;
          }
        });
      }
      return filtered;
    };
  }

  private loadInvoiceOrders(params, invoice) {
    this.isSubLoading = true;
    this.wellApiService.getInvoicedOrders(this.selectedFracId, params).subscribe((orders) => {
      for (let i = 0; i < this.invoices.length; i++) {
        if (
          this.invoices[i].InvoiceNumber === invoice.InvoiceNumber &&
          this.invoices[i].vendorId === invoice.vendorId
        ) {
          this.invoices[i].orders = new MatTableDataSource(orders);
          this.isSubLoading = false;
        }
      }
    });
  }

  private updateFilterStore() {
    if (this.storedFilter[this.urlRoute]) {
      if (this.urlRoute !== TABS.INVOICE_APPROVED && this.urlRoute !== TABS.WAITING_FOR_INVOICE_APPROVAL) {
        this.storedFilter[this.urlRoute].isAutomated = this.isAutomated;
        this.storedFilter[this.urlRoute].isManual = this.isManual;
        this.storedFilter[this.urlRoute].pushback = this.pushback;
        this.storedFilter[this.urlRoute].attachmentFilter = this.attachmentFilter;
        this.storedFilter[this.urlRoute].recentFilter = this.olderThanTwoDays;
        this.storedFilter[this.urlRoute].pushedBackInvoiceNumber = this.pushedBackInvoiceNumber;
        this.storedFilter[this.urlRoute].dataMatchedFilter = this.dataMatchedFilter;
        this.storedFilter[this.urlRoute].fastTrackedFilter = this.fastTrackedFilter;
        this.storedFilter[this.urlRoute].needsManualApprovalPricing = this.needsManualApprovalPricing;
        this.storedFilter[this.urlRoute].needsManualApprovalTrip = this.needsManualApprovalTrip;
        this.storedFilter[this.urlRoute].needsManualApprovalBOL = this.needsManualApprovalBOL;
        this.storedFilter[this.urlRoute].needData = this.needData;
        this.storedFilter[this.urlRoute].manuallyEdited = this.manuallyEdited;
        this.storedFilter[this.urlRoute].pageLimit = this.pageLimit;
        this.storedFilter[this.urlRoute].pageOffset = this.pageOffset;
        this.storedFilter[this.urlRoute].pageColumn = this.pageColumn;
        this.storedFilter[this.urlRoute].pageOrderBy = this.pageOrderBy;
        this.storedFilter[this.urlRoute].searchData = this.searchData;
        this.storedFilter[this.urlRoute].pageIndex = this.pageIndex;
      } else {
        this.storedFilter[this.urlRoute].pageIndexInvoice = this.pageIndexInvoice;
        this.storedFilter[this.urlRoute].pageOffsetInvoice = this.pageOffsetInvoice;
        this.storedFilter[this.urlRoute].pageLimitInvoice = this.pageLimitInvoice;
      }
    }
  }

  private unsubscribeAPIDataCall() {
    if (this.dataAPICall) {
      this.dataAPICall.unsubscribe();
      this.dataAPICall = null;
    }
  }

  private searchOrders(params, searchNumber) {
    this.unsubscribeAPIDataCall();
    this.dataAPICall = this.wellApiService.getCompletedFrac(this.selectedFracId, params).subscribe((data) => {
      if (this.searchNumber === searchNumber) {
        if (data.Orders) {
          this.completedOrders = data.Orders;
          localStorage.removeItem(LOCAL_STORAGE_CONST.BILLING_ORDER_IDS);
          localStorage.setItem(
            LOCAL_STORAGE_CONST.BILLING_ORDER_IDS,
            JSON.stringify(this.completedOrders.map((order) => order.id)),
          );
        }
        this.getOrderForwardStatus();
        this.orderCount = data.Count;
        this.initializeTable();
      }
    });
  }

  private getOrderForwardStatus() {
    if (this.completedOrders && this.completedOrders.length) {
      this.wellApiService
        .getOrdersForwardStatus({ orderIds: this.completedOrders.map((order) => order.id) })
        .subscribe((data) => {
          this.ordersTooltips = [...data];
        });
    }
  }

  private getTooltipData(order) {
    const selectedOrder = this.ordersTooltips.find((orderData) => orderData.orderId === order.id);
    if (
      selectedOrder &&
      (selectedOrder.missingTimeStamp ||
        selectedOrder.missingBolDetails ||
        selectedOrder.manualPricingChange ||
        selectedOrder.missingAttachment)
    ) {
      const reasonArray = [];
      if (selectedOrder.missingTimeStamp) {
        reasonArray.push('Missing GoHawk Timestamp');
      }
      if (selectedOrder.missingBolDetails) {
        reasonArray.push('Missing BOL Details');
      }
      if (selectedOrder.manualPricingChange) {
        reasonArray.push('Changed Pricing Details');
      }
      if (selectedOrder.missingAttachment) {
        reasonArray.push('Missing Attachment');
      }
      return reasonArray.join();
    } else {
      return null;
    }
  }

  updateSubOrders(element) {
    const selectedInvoice = this.invoices.find((invoice) => {
      return invoice.InvoiceNumber === element.InvoiceNumber && invoice.vendorId === element.vendorId;
    });
    if (!selectedInvoice.orders) {
      const params = {
        invoiceNumber: element.InvoiceNumber.trim(),
        vendorId: element.vendorId,
      };
      this.loadInvoiceOrders(params, element);
    }
  }

  public calculateBoostCharge(order) {
    return (order.lineHaul * (order.boostPercent || 0)) / 100;
  }

  fetchPageData(page) {
    if (this.showOrderTable()) {
      this.pageOffset = page.pageIndex * PAGE_SIZE;
      this.pageIndex = page.pageIndex;
    } else {
      this.pageOffsetInvoice = page.pageIndex * PAGE_SIZE_INVOICE;
      this.pageIndexInvoice = page.pageIndex;
    }
    this.selection.clear();
    this.loadData();
  }

  checkForMissing(order) {
    if (order.bolNumber === '' || !order.bolNumber) {
      return 'BOL Needed';
    }
  }

  checkForPushBack(order) {
    switch (this.urlRoute) {
      case TABS.NEED_DATA_FOR_TICKETING:
        return (
          order.orderStatusChangeHistory &&
          order.orderStatusChangeHistory.oldValue === BILLING_STATUS.approvedByDispatcher &&
          order.orderStatusChangeHistory.newValue === BILLING_STATUS.notBilled
        );
      case TABS.READY_FOR_INVOICING:
        return (
          order.orderStatusChangeHistory &&
          order.orderStatusChangeHistory.oldValue === BILLING_STATUS.billed &&
          order.orderStatusChangeHistory.newValue === BILLING_STATUS.approvedByLMO
        );
      case TABS.WAITING_FOR_TICKET_APPROVAL:
        return (
          order.orderStatusChangeHistory &&
          order.orderStatusChangeHistory.oldValue === BILLING_STATUS.approvedByLMO &&
          order.orderStatusChangeHistory.newValue === BILLING_STATUS.approvedByDispatcher
        );
      default:
        return false;
    }
  }

  checkForApprove(order) {
    if (order.orderApproveStatus) {
      let error = '';
      let first = true;
      if (!order.orderApproveStatus.pricingApproved) {
        error += 'Pricing Changed';
        first = false;
      }
      if (!order.orderApproveStatus.tripApproved) {
        if (!first) {
          error += ', ';
        }
        error += 'Trip Changed';
        first = false;
      }
      if (!order.orderApproveStatus.bolApproved) {
        if (!first) {
          error += ', ';
        }
        error += 'Edited Payload Details';
      }
      return error;
    }
  }

  checkForEditableOrder(order) {
    switch (this.urlRoute) {
      case TABS.WAITING_FOR_TICKET_APPROVAL:
        return 'This load cannot be edited while waiting for ticket approval.';
      case TABS.WAITING_FOR_INVOICE_APPROVAL:
        return 'This load cannot be edited while waiting for invoice approval';
      case TABS.INVOICE_APPROVED:
        return 'This load cannot be edited as it has already been billed.';
      default:
        return '';
    }
  }

  checkIfReceivedByCustomer(order) {
    return this.urlRoute === TABS.INVOICE_APPROVED && this.userService.isAPIUser() && !order.retrievedByAPI;
  }

  initializeTable() {
    if (!this.showOrderTable()) {
      const totalArray = Array(this.invoiceCount).fill({});
      this.invoiceDataSource.data = totalArray.map((_, idx) => {
        if (idx >= this.pageOffsetInvoice && idx < this.pageOffsetInvoice + PAGE_SIZE_INVOICE) {
          const toReturn = this.completeInvoices[idx % PAGE_SIZE_INVOICE];
          return toReturn;
        }
        return _;
      });
      this.paginatorInvoice.pageIndex = this.pageIndexInvoice;
      this.invoiceDataSource.paginator = this.paginatorInvoice;
    } else {
      const totalArray = Array(this.orderCount).fill({});
      this.activeDataSource.data = totalArray.map((_, idx) => {
        if (idx >= this.pageOffset && idx < this.pageOffset + PAGE_SIZE) {
          const toReturn = this.completedOrders[idx % PAGE_SIZE];
          return toReturn;
        }
        return _;
      });
      this.paginator.pageIndex = this.pageIndex;
      this.activeDataSource.paginator = this.paginator;
      this.activeDataSource.sort = this.sort;
    }
    this.isLoading = false;
  }

  selectRow(order) {
    this.router.navigate(['./' + order.id], { relativeTo: this.route });
  }

  openTicketModal() {
    if (!this.useShaleAppsInvoiceNumber) {
      let selectedInvoice = this.selection.selected[0].invoiceNumber || null;
      selectedInvoice = this.selection.selected.every((o) => o.invoiceNumber === selectedInvoice)
        ? selectedInvoice
        : '';
      const dialogRef = this.dialog.open(TicketDialogComponent, {
        width: '300px',
        maxWidth: '968px',
        data: selectedInvoice,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.batchOrdersForInvoicing(result);
        }
      });
    } else {
      this.batchOrdersForInvoicing();
    }
  }

  batchOrdersForInvoicing(invoiceNumber?: string) {
    this.savingData = true;
    const idArray = [];
    this.selection.selected.forEach((order) => {
      idArray.push(order.id);
    });
    let body: any = {
      orderIds: idArray,
      fracId: +this.selectedFracId,
    };
    if (invoiceNumber) {
      body = { ...body, invoiceNumber: invoiceNumber.trim() };
    }
    this.orderApiService.billOrders(body).subscribe(
      (resp) => {
        this.savingData = false;
        this.fetchData();
        let failedOrderIds = [];
        if (resp.failedOrderIds && resp.failedOrderIds.length) {
          failedOrderIds = resp.failedOrderIds.filter((order) => order !== '');
        }
        if (failedOrderIds.length) {
          this.snackbar.open(
            idArray.length === failedOrderIds.length
              ? `Failed to Batch Orders ${failedOrderIds.join()}`
              : `Batched all orders except for ${failedOrderIds.join()}.`,
            null,
            {
              duration: 5000,
              panelClass: ['snackbar-error'],
            },
          );
        } else {
          if (this.singleOrderPerInvoice) {
            this.snackbar.open(`${idArray.length} order(s) billed successfully`, null, {
              duration: 5000,
            });
          } else {
            const snackbarRef = this.snackbar.open(
              `Successfully batched SA${resp.invoiceNumber}`,
              'Copy to Clipboard',
              {
                duration: 5000,
              },
            );
            snackbarRef.onAction().subscribe((_) => {
              this.textToClipboard(`SA${resp.invoiceNumber}`);
              this.snackbar.open(`SA${resp.invoiceNumber} Copied to Clipboard`, null, {
                duration: 2000,
              });
            });
          }
        }
      },
      (err) => {
        this.savingData = false;
        this.errorHandler.showError(err, 5000);
      },
    );
  }

  textToClipboard(text) {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    dummy.setSelectionRange(0, 99999); // For Mobile Devices
    document.execCommand('copy');
    document.body.removeChild(dummy);
  }

  approveOrders() {
    this.savingData = true;
    const orderIds = this.selection.selected.map((order) => {
      return order.id;
    });
    if (this.urlRoute === TABS.WAITING_FOR_TICKET_APPROVAL) {
      this.orderApiService.approveOrders(orderIds).subscribe(
        (_) => {
          this.savingData = false;
          this.snackbar.open('Order approved for invoicing Successfully', null, {
            duration: 5000,
          });
          this.selection.clear();
          this.loadData();
        },
        (err) => {
          this.savingData = false;
          this.errorHandler.showError(`Update Failed`, 5000);
        },
      );
    } else if (this.urlRoute === TABS.WAITING_FOR_INVOICE_APPROVAL) {
      this.orderApiService.approveInvoices(orderIds).subscribe(
        (_) => {
          this.savingData = false;
          this.snackbar.open('Invoice Approved Successfully', null, {
            duration: 5000,
          });
          this.selection.clear();
          this.loadData();
        },
        (err) => {
          this.savingData = false;
          this.errorHandler.showError(`Update Failed`, 5000);
        },
      );
    }
  }

  approveBulkInvoices(event) {
    event.stopPropagation();
    this.savingData = true;
    const isOtherOrders = this.selection.selected.find((order) => order.isBatchedWithOtherOrders);
    if (!this.groupByInvoiceFilter.value && isOtherOrders) {
      const confirmDialogRef = this.dialog.open(ConfirmActionDialogComponent, {
        data: {
          title: 'Approve All Loads for this Invoice?',
          desc:
            'There are multiple loads billed on this invoice. Would you like to approve all loads for this invoice?',
          cancelButtonText: 'Cancel',
          submitButtonText: 'Approve',
        },
      });
      confirmDialogRef
        .afterClosed()
        .pipe(filter(Boolean))
        .subscribe((_) => {
          this.bulkApprove();
        });
      this.savingData = false;
    } else {
      this.bulkApprove();
    }
  }

  private bulkApprove() {
    const body = [
      ...this.selection.selected.map((selected) => {
        return {
          vendorId: !this.groupByInvoiceFilter.value ? selected.vendor.id : selected.vendorId,
          invoiceNumber: !this.groupByInvoiceFilter.value
            ? selected.invoiceNumber.trim()
            : selected.InvoiceNumber.trim(),
          isOneClickApproved: false,
        };
      }),
    ];
    this.wellApiService.approveInvoiceChanges(this.selectedFracId, body).subscribe(
      (resp) => {
        this.savingData = false;
        this.snackbar.open('Invoiced Orders Approved Successfully', null, {
          duration: 5000,
        });
        this.selection.clear();
        this.loadData();
      },
      (err) => {
        this.savingData = false;
        this.errorHandler.showError(`Unable to approve invoiced orders.`, 5000);
      },
    );
  }

  exportInvoiceDetails(event, element, index) {
    event.stopPropagation();
    this.exporting[index] = true;
    const body = {
      invoiceNumber: !this.groupByInvoiceFilter.value ? element.invoiceNumber : element.InvoiceNumber,
      vendorId: !this.groupByInvoiceFilter.value ? element.vendor.id : element.vendorId,
    };
    this.wellApiService.exportInvoices(this.selectedFracId, body).subscribe(
      (data) => {
        this.exporting[index] = false;
        window.open(data, '_blank');
      },
      (error) => {
        this.exporting[index] = false;
        this.errorHandler.showError('Error downloading the file.');
      },
    );
  }

  rejectBulkInvoices(event) {
    this.savingData = true;
    event.stopPropagation();
    const isOtherOrders = this.selection.selected.find((order) => order.isBatchedWithOtherOrders);
    if (!this.groupByInvoiceFilter.value && isOtherOrders) {
      const confirmDialogRef = this.dialog.open(ConfirmActionDialogComponent, {
        data: {
          title: 'Reject All Loads for this Invoice?',
          desc: 'There are multiple loads billed on this invoice. Would you like to reject all loads for this invoice?',
          cancelButtonText: 'Cancel',
          submitButtonText: 'Reject',
        },
      });
      confirmDialogRef
        .afterClosed()
        .pipe(filter(Boolean))
        .subscribe((_) => {
          this.bulkReject();
        });
      this.savingData = false;
    } else {
      this.bulkReject();
    }
  }

  private bulkReject() {
    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      width: '30%',
      maxWidth: '968px',
      data: 'approved_by_lmo',
    });
    dialogRef
      .afterClosed()
      .pipe(filter(Boolean))
      .subscribe((result: any) => {
        if (result.status) {
          const body = {
            invoices: [
              ...this.selection.selected.map((selected) => {
                return {
                  vendorId: !this.groupByInvoiceFilter.value ? selected.vendor.id : selected.vendorId,
                  invoiceNumber: !this.groupByInvoiceFilter.value
                    ? selected.invoiceNumber.trim()
                    : selected.InvoiceNumber.trim(),
                };
              }),
            ],
            pushbackReason: result.reason,
          };
          this.wellApiService.rejectInvoiceChanges(this.selectedFracId, body).subscribe(
            (resp) => {
              this.savingData = false;
              this.snackbar.open('Invoiced Orders Rejected Successfully', null, {
                duration: 5000,
              });
              this.selection.clear();
              this.reloadFracData();
              this.loadData();
            },
            (err) => {
              this.savingData = false;
              this.errorHandler.showError(`Unable to reject invoiced orders.`, 5000);
            },
          );
        }
      });
    this.savingData = false;
  }

  rejectApprovedInvoice(event, invoice) {
    event.stopPropagation();
    if (!this.groupByInvoiceFilter.value && invoice.isBatchedWithOtherOrders) {
      const confirmDialogRef = this.dialog.open(ConfirmActionDialogComponent, {
        data: {
          title: 'Undo Approve All Loads for this Invoice?',
          desc:
            'There are multiple loads billed on this invoice. Would you like to undo approve all loads for this invoice?',
          cancelButtonText: 'Cancel',
          submitButtonText: 'Undo Approval',
        },
      });
      confirmDialogRef
        .afterClosed()
        .pipe(filter(Boolean))
        .subscribe((_) => {
          this.undoApproval(invoice);
        });
    } else {
      this.undoApproval(invoice);
    }
  }

  private undoApproval(invoice) {
    const body: any = {
      invoiceNumber: !this.groupByInvoiceFilter.value ? invoice.invoiceNumber : invoice.InvoiceNumber,
      vendorId: !this.groupByInvoiceFilter.value ? invoice.vendor.id : invoice.vendorId,
    };
    this.wellApiService.rejectApprovedInvoices(this.selectedFracId, body).subscribe(
      (_) => {
        this.snackbar.open(
          `Invoice "${invoice.InvoiceNumber || invoice.invoiceNumber}" moved back to Waiting for Invoice Approval`,
          null,
          {
            duration: 5000,
          },
        );
        this.loadData();
      },
      (err) => {
        this.errorHandler.showError(err, 5000);
      },
    );
  }

  close(changed) {
    this.selectedFracId = this.route.parent.snapshot.params['id'];
    this.selection.clear();
    this.loadBaseData();
    this.detailView = false;
    this.urlOrderId = null;
  }

  public checkForNonFinancialImpact(order) {
    return order.orderBillingHistory && order.orderBillingHistory.length;
  }

  loadRecent() {
    const extras: any = {
      relativeTo: this.route,
    };
    if (this.olderThanTwoDays) {
      extras.queryParams = { older: this.olderThanTwoDays };
    }
    this.router.navigate([], extras).then((res) => {
      this.fetchData();
    });
  }
}
